/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeOrderReqVo
 */
export interface MergeOrderReqVo {
    /**
     * 目标订单ID
     * @type {number}
     * @memberof MergeOrderReqVo
     */
    targetOrderId?: number;
    /**
     * 需要被合到目标订单的订单ID列表
     * @type {Array<number>}
     * @memberof MergeOrderReqVo
     */
    sourceOrderIds?: Array<number>;
}

/**
 * Check if a given object implements the MergeOrderReqVo interface.
 */
export function instanceOfMergeOrderReqVo(value: object): value is MergeOrderReqVo {
    return true;
}

export function MergeOrderReqVoFromJSON(json: any): MergeOrderReqVo {
    return MergeOrderReqVoFromJSONTyped(json, false);
}

export function MergeOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'targetOrderId': json['targetOrderId'] == null ? undefined : json['targetOrderId'],
        'sourceOrderIds': json['sourceOrderIds'] == null ? undefined : json['sourceOrderIds'],
    };
}

export function MergeOrderReqVoToJSON(json: any): MergeOrderReqVo {
    return MergeOrderReqVoToJSONTyped(json, false);
}

export function MergeOrderReqVoToJSONTyped(value?: MergeOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetOrderId': value['targetOrderId'],
        'sourceOrderIds': value['sourceOrderIds'],
    };
}

